module.exports = __webpack_public_path__ + "media/images/downarrow-5af083e5b99196899e3e12b62c5fbe60.png";